import { TextField } from "@mui/material";
import { GridFilterOperator } from "@mui/x-data-grid-pro";
import createFilter from "./helpers/CreateFilterHelper";

const CustomFilterOperatorInputNumber = (props: any) => {
  const { item, applyValue } = props;

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (!event.ctrlKey && event.key !== "Enter") {
      event.stopPropagation();
    }
  };

  const handleChange = (event: any) => {
    // stop if not a number less than 2147483647 or greater than -2147483648
    if (isNaN(event.target.value) || event.target.value > 2147483647 || event.target.value < -2147483648) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    applyValue({ ...item, value: event.target.value });
  };
  return <TextField       
      placeholder={props.label} 
      onKeyDown={handleKeyDown} 
      variant="filled" 
      size="small" 
      type="number" 
      value={item.value || ''} 
      onChange={handleChange} 
      inputProps={{ inputMode: 'numeric', pattern: '^[0-9]{1,10}$', maxLength: 10, "aria-label":"Number Filter Input" }}       
  />;
};

const NumberFilterOperator: GridFilterOperator[] = [
  {
      label: 'Equals',
      value: 'eq',
      getApplyFilterFn: createFilter((cellValue, filterValue) => {
          if (cellValue === undefined || filterValue === undefined) return false;
          return Number(cellValue) === Number(filterValue);
      }),
      InputComponentProps: { type: 'text' },
      InputComponent: CustomFilterOperatorInputNumber,
  },
  {
      label: 'Less Than',
      value: 'lt',
      getApplyFilterFn: createFilter((cellValue, filterValue) => {
          if (cellValue === undefined || filterValue === undefined) return false;
          return Number(cellValue) < Number(filterValue);
      }),
      InputComponentProps: { type: 'text' },
      InputComponent: CustomFilterOperatorInputNumber,
  },
  {
      label: 'Greater Than',
      value: 'gt',
      getApplyFilterFn: createFilter((cellValue, filterValue) => {
          if (cellValue === undefined || filterValue === undefined) return false;
          return Number(cellValue) > Number(filterValue);
      }),
      InputComponentProps: { type: 'text' },
      InputComponent: CustomFilterOperatorInputNumber,
  },
  {
      label: 'Not Equals',
      value: 'neq',
      getApplyFilterFn: createFilter((cellValue, filterValue) => {
          if (cellValue === undefined || filterValue === undefined) return false;
          return Number(cellValue) !== Number(filterValue);
      }),
      InputComponentProps: { type: 'text' },
      InputComponent: CustomFilterOperatorInputNumber,
  },
];

export default NumberFilterOperator;